import { render, staticRenderFns } from "./ChallengeSummary.vue?vue&type=template&id=34f2b920&"
import script from "./ChallengeSummary.vue?vue&type=script&lang=js&"
export * from "./ChallengeSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports